import { useMutation, useQueryClient } from 'react-query';
import { deleteRecognitionAsync } from 'services/Recognition';
import { RECOGNITION_KEYS } from 'services/Recognition/hooks/useQuery';
import { IRecognitionTypes } from '../../../types';
import {
  createResponsibleRecognitionAsync,
  getAllResponsibleByLicenseAsync,
  getAllResponsiblesForSelectionAsync,
  getResponsibleRecognitionByIdAsync,
  updateResponsibleRecognitionAsync,
} from '../../index';
import { RESPONSIBLE_KEYS } from '../useQuery';

export const useCreateResponsibleRecognitionAsync = () => {
  const queryClient = useQueryClient();
  
  return useMutation(createResponsibleRecognitionAsync, {
    onSuccess: () => {
      queryClient.invalidateQueries([RESPONSIBLE_KEYS.ALL]);
    }
  });
};

export const useUpdateResponsibleRecognitionAsync = () => {
  const queryClient = useQueryClient();
  
  return useMutation(updateResponsibleRecognitionAsync, {
    onSuccess: () => {
      queryClient.invalidateQueries([RESPONSIBLE_KEYS.ALL]);
    }
  });
};

export const useDeleteResponsibleAsync = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (id: number) => deleteRecognitionAsync({ id, type: IRecognitionTypes.RESPONSIBLE }), 
    {
      onSuccess: () => {
        queryClient.invalidateQueries([RESPONSIBLE_KEYS.ALL]);
        queryClient.invalidateQueries([RECOGNITION_KEYS.ALL]); 
      }
    }
  );
};

export const useGetResponsibleRecognitionByIdAsync = () =>
  useMutation(getResponsibleRecognitionByIdAsync);

export const useGetAllResponsibleByLicenseMutateAsync = () =>
  useMutation(getAllResponsibleByLicenseAsync);

export const useGetAllResponsiblesForSelectionMutateAsync = () => {
  return useMutation(getAllResponsiblesForSelectionAsync);
};
